module.exports = __webpack_public_path__ + "static/media/articles4.d8ffc4a3.png";